import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from '../assets/styles/components/TakeawaySummary'
import cx from 'classnames'
import { Flex } from 'antd-mobile'
import cookingImage from '../assets/images/cooking.png'
import moment from 'moment'
import * as _ from 'lodash'
import QRcode from 'qrcode.react'
import { DELIVERY_TYPE_SHOP } from '../constants/merchant'
import qs from 'qs'
import Confirmation from '../containers/scenes/Confirmation'
import { setStorage } from '../store/localStorage';

class TakeawayWaitingSummaryComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      status: props.status,
      code: '',
      serial: '',
      pickupAt: null,
      basket: {},
      isInit: false,
    }
    this.isCampaignCCBMerchant = false
  }

  init () {
    const { basket, query } = this.props
    if (this.state.isInit === false && (!query.params.m || basket.merchantId === query.params.m)) {
      this.setState({ isInit: true })
      this.fetchBasket()
      this.timer = setInterval(() => {
        this.fetchBasket()
      }, 10 * 1000)
    }
    setStorage('wc_payload', {});
  }

  async fetchBasket () {
    const {
      basket,
      history,
      // query,
    } = this.props

    const res = await this.props.getBasket({ id: basket.id })
    this.props.setTakeawayWaitingBasket(res)
    if (res.status === 'pending') {
      const path = '/home'
      history.push(path)
      console.info('route changed', path)
      return
    }

    const pickupAt = moment(res.pickupAt).local().format('M/D HH:mm')
    this.setState({
      basket: res,
      serial: res.serial,
      code: res.code, // > getBasket 取得四碼取餐碼，存入 state。
      pickupAt,
      status: res.takeawayStatus,
      cancelReason: res.cancelReason,
    })

    this.props.updateParentState({
      method: res.payment,
      basket: res,
    })

    const completeStatuses = {
      lalamove: ['cancelled', 'delivered'],
    }

    if (completeStatuses[res.shippingProvider]) {
      if (completeStatuses[res.shippingProvider].includes(res.takeawayStatus)) {
        clearInterval(this.timer)
      }
    } else if (['cancelled', 'completed'].includes(res.takeawayStatus)) {
      clearInterval(this.timer)
    }
  }

  componentDidUpdate = () => this.init()
  componentDidMount = () => this.init()
  componentWillUnmount = () => clearInterval(this.timer)

  handleBackToHome = async () => {
    const {
      history,
      setTakeawayStatus,
      setTakeawayAvailable,
      setDeliveryAvailable,
      createBasket,
      merchant,
      removePromoCode,
    } = this.props

    setTakeawayStatus(undefined)
    removePromoCode()
    try {
      await createBasket({
        merchantId: merchant.id,
      })
    } catch (err) {
      if (err.response && err.response.status >= 400 && err.response.status < 500) {
        if (err.response.data.error === 'not for takeaway') {
          await setTakeawayAvailable(false)
        }
        if (err.response.data.error === 'not for delivery') {
          await setDeliveryAvailable(false)
        }
      }
    } finally {
      const params = qs.stringify({
        m: merchant.id,
        dir: true,
      })
      window.location.href = `${window.location.protocol}//${window.location.host}?${params}`
    }
  }

  render () {
    const {
      classes,
      merchant,
      intl,
      user,
      basket,
      campaign,
    } = this.props

    if (!merchant) return <div />
    this.isCampaignCCBMerchant = Boolean(campaign.ccb.merchants.find(m => m.id === merchant.id))

    const containerStyle = cx(classes['takeaway-summary-info-container'])
    const coverContainerStyle = cx(classes['takeaway-summary-cover-container'])
    // const coverStyle = cx(classes['takeaway-summary-cover'])
    const headerStyle = cx(classes['takeaway-summary-header'])
    const h1Style = cx(classes['takeaway-summary-h1'])
    const subHeaderStyle = cx(classes['takeaway-summary-sub-header'])
    const reorderLineStyle = cx(classes['takeaway-reorder-line'])
    const waitingCodeStyle = cx(classes['takeaway-summary-waiting-code'])
    const waitingCodeBoundaryStyle = cx(classes['takeaway-summary-waiting-code-boundary'])
    const waitingCodeBoundaryLastStyle = cx(classes['takeaway-summary-waiting-code-boundary-last'])
    const bgShapeCheckoutStyle = cx(classes['bg-shape'], classes['bg-shape-checkout'])
    const codeWrapStyle = cx(classes['code-wrap'])
    const waitingCodeWrapStyle = cx(classes['waiting-code-wrap'])
    const pickupAtTextStyle = cx(classes['pickup-at-text'])
    const cookingImageStyle = cx(classes['cooking-img'])
    const takeawayOrderStatusStyle = cx(classes['takeaway-order-status-wrap'])
    const merchantContactWrapStyle = cx(classes['merchant-contact-wrap'])
    const takeawayStatusBodyStyle = cx(classes['takeaway-status-body'])
    const resumbitBtnStyle = cx(classes['resubmit-button'])
    const resubmitAfterOrderCompleteBtnStyle = cx(classes['resubmit-after-order-complete-button'])
    const resubmitAfterOrderCompleteBtnDisabledStyle = cx(classes['resubmit-after-order-complete-button-disabled'])
    const takeawayOrderStatusContentStyle = cx(classes['takeaway-order-status-content-wrap'])

    const renderDeliveryAddress = () => {
      const _deliveryAddressText = intl.formatMessage({ id: 'summary.restaurant.info.delivery.address' })
      let deliveryAddress = []
      if (this.props.locale === 'zh') {
        deliveryAddress = [
          _.get(this.state.basket, ['shipping', 'lalamove', 'endAddress'], ''),
          _.get(this.state.basket, ['shipping', 'lalamove', 'endBuilding'], ''),
          _.get(this.state.basket, ['shipping', 'lalamove', 'endFloorRoom'], ''),
        ]
      } else {
        deliveryAddress = [
          _.get(this.state.basket, ['shipping', 'lalamove', 'endFloorRoom'], ''),
          _.get(this.state.basket, ['shipping', 'lalamove', 'endBuilding'], ''),
          _.get(this.state.basket, ['shipping', 'lalamove', 'endAddress'], ''),
        ]
      }
      deliveryAddress = deliveryAddress.filter(o => o).join('\n') || this.state.basket.address
      if (
        this.state.basket.address &&
        !this.state.basket.delivery &&
        merchant &&
        merchant.setting.takeawayAddress
      ) {
        return (
          <div>
            <div className={subHeaderStyle}>
              {_deliveryAddressText}
            </div>
            <div style={{ wordBreak: 'break-word', whiteSpace: 'break-spaces' }}>
              {deliveryAddress}
            </div>
          </div>
        )
      }
    }

    const renderDeliveryPickupAt = () => {
      const _pickupTimeText = intl.formatMessage({ id: 'takeaway.summary.pickup.time' })

      return (
        <div>
          <div className={subHeaderStyle}>
            {_pickupTimeText}
          </div>
          <div>{moment(this.state.basket.pickupAt).format('LL dddd LT')}</div>
        </div>
      )
    }

    const renderPickupCode = () => {
      const _codeHeaderText = intl.formatMessage({ id: 'takeaway.summary.restaurant.code.header' })
      const _pickupTimeText = intl.formatMessage({ id: 'takeaway.summary.pickup.time' })

      const qrstring = `completeTakeawayOrder:${basket.id}:${this.state.code}`

      // > 改成出餐後顯示 pickup code 和 QR code。
      if (this.state.status === 'ready' && this.state.basket.deliveryType === 'takeaway') {
        return (
          <div>
            <Flex className={codeWrapStyle}>
              <Flex.Item className={headerStyle}><div className={bgShapeCheckoutStyle} /> {_codeHeaderText} </Flex.Item>
              <Flex.Item align='right'><span className={subHeaderStyle}> {_pickupTimeText}:</span> <span className={pickupAtTextStyle}>{this.state.pickupAt} </span></Flex.Item>
            </Flex>
            {/**
              // > 刷卡外帶的 4 碼驗證碼，現為 Merchant 端輸入，將增加由 Waiter 端掃描 QRcode 的方式進行確認。
            */}
            <Flex className={waitingCodeWrapStyle}>
              <Flex.Item className={waitingCodeStyle} align='center'> <div className={waitingCodeBoundaryStyle}>  </div> <span style={{ zIndex: '10' }}> {this.state.code.split('')[0]}</span> </Flex.Item>
              <Flex.Item className={waitingCodeStyle} align='center'> <div className={waitingCodeBoundaryStyle}>  </div> <span style={{ zIndex: '10' }}>{this.state.code.split('')[1]}</span></Flex.Item>
              <Flex.Item className={waitingCodeStyle} align='center'> <div className={waitingCodeBoundaryStyle}>  </div> <span style={{ zIndex: '10' }}>{this.state.code.split('')[2]}</span></Flex.Item>
              <Flex.Item className={waitingCodeStyle} align='center'> <div className={waitingCodeBoundaryLastStyle}>  </div> <span style={{ zIndex: '10' }}>{this.state.code.split('')[3]}</span> </Flex.Item>
            </Flex>
            {/**
              // > 將 takeawayOrder.id 和 this.state.code 的四碼驗證碼組合轉為 QRcode。
            */}
            <Flex>
              <Flex.Item align='center'>
                <QRcode
                  value={qrstring}
                  size={200}
                  includeMargin
                />
              </Flex.Item>
            </Flex>
          </div>
        )
      }
    }

    const renderRestaurantInfo = () => {
      let _deliveryTypeyText
      if (this.state.basket.deliveryType) {
        _deliveryTypeyText = intl.formatMessage({ id: 'summary.deliveryType.' + this.state.basket.deliveryType })
      }
      const _serialText = intl.formatMessage({ id: 'checkout.serial' })
      const _restaurantText = intl.formatMessage({ id: 'summary.restaurant.info' })
      const _shopText = intl.formatMessage({ id: 'summary.shop.info' })
      const _nameText = intl.formatMessage({ id: 'summary.restaurant.info.name' })
      const _addressText = intl.formatMessage({ id: 'summary.restaurant.info.address' })
      const _telText = intl.formatMessage({ id: 'summary.restaurant.info.tel' })

      const _merchantName = merchant ? merchant.name : ''
      const _merchantAddress = merchant ? merchant.address : ''
      const _merchantContact = merchant ? merchant.contact : ''

      var banner = ''
      if (merchant != null) {
        // banner = (
        //   <img
        //     className={coverStyle}
        //     src={cloudinary.transformation(merchant.images.cover, 'h_80')}
        //     alt=''
        //   />
        // )
      }

      return (
        <React.Fragment>
          {
            this.state.basket.deliveryType &&
            <div className={h1Style}>
              {_deliveryTypeyText}
            </div>
          }

          <div className={headerStyle}>{_serialText}: {this.state.serial}</div>

          <div className={coverContainerStyle}>{banner}</div>

          <div className={headerStyle}>
            <div className={bgShapeCheckoutStyle} />{
              this.state.basket.deliveryType === DELIVERY_TYPE_SHOP
                ? _shopText
                : _restaurantText
            }</div>

          <div className={subHeaderStyle}>{_nameText}</div>
          <div>{_merchantName}</div>

          <div className={subHeaderStyle}>{_addressText}</div>
          <div>{_merchantAddress}</div>

          {/* <div className={subHeaderStyle}>{_telText}</div>
          <div className={merchantContactWrapStyle}>
            <a href={'tel:' + _merchantContact}>{_merchantContact}</a>
          </div> */}
        </React.Fragment>
      )
    }

    const renderUserInfo = () => {
      const _deliveryAddress = user ? user.address : ''
      const _deliveryAddressText = intl.formatMessage({ id: 'summary.restaurant.info.delivery.address' })
      const _userNameText = intl.formatMessage({ id: 'summary.name' })
      const _userTelText = intl.formatMessage({ id: 'summary.tel_placeholder' })
      const _pickupTimeText = intl.formatMessage({ id: 'takeaway.summary.pickup.time' })

      if (this.state.basket.delivery === true) {
        return (
          <React.Fragment>
            <div>
              <div className={subHeaderStyle}>{_deliveryAddressText}</div>
              <div>{_deliveryAddress}</div>
            </div>

            <div>
              <div className={subHeaderStyle}>{_userNameText}</div>
              <div>{this.state.basket.name}</div>
            </div>

            <div>
              <div className={subHeaderStyle}>{_userTelText}</div>
              <div>{this.state.basket.phone}</div>
            </div>

            {this.state.basket.dropoffAt && (
              <div>
                <div className={subHeaderStyle}>{_pickupTimeText}</div>
                <div>{moment(this.state.basket.dropoffAt).subtract(15, 'minutes').format('YYYY-MM-DD HH:mm') + ' - ' + moment(this.state.basket.dropoffAt).format('HH:mm')}</div>
              </div>
            )}
          </React.Fragment>
        )
      }
    }

    const renderOrderStatus = () => {
      let _statusText = intl.formatMessage({ id: 'takeaway.status.pending' })
      let takeawayOrderStatusTextStyle = cx(classes['takeaway-order-status-text'])
      let shouldShowResubmitBtn = false
      const { basket } = this.state
      switch (this.state.status) {
        case 'pending':
          _statusText = intl.formatMessage({ id: 'takeaway.status.pending' })
          shouldShowResubmitBtn = false
          break
        case 'confirmed':
          _statusText = intl.formatMessage({ id: 'takeaway.status.confirmed' })
          shouldShowResubmitBtn = false
          break
        case 'ready':
          _statusText = intl.formatMessage({ id: 'takeaway.status.ready' })
          takeawayOrderStatusTextStyle = cx(classes['takeaway-order-status-text-highlight'])
          shouldShowResubmitBtn = false
          break
        case 'cancelled':
          _statusText = intl.formatMessage({ id: 'takeaway.status.cancelled' })
          if (this.state.cancelReason) {
            _statusText += '\n' + intl.formatMessage({ id: 'takeaway.cancel_reason' }) +
             ': ' +
              intl.formatMessage({ id: `takeaway.cancel.${this.state.cancelReason}`, defaultMessage: this.state.cancelReason })
          }
          takeawayOrderStatusTextStyle = cx(classes['takeaway-order-status-text-cancelled'])
          shouldShowResubmitBtn = true
          break
        case 'completed':
          shouldShowResubmitBtn = true
          if (basket.deliveryType === 'storeDelivery') {
            _statusText = intl.formatMessage({ id: 'storedelivery.status.completed' })
            if (basket.shippingProvider === 'lalamove') {
              shouldShowResubmitBtn = false
            }
          } else if (basket.deliveryType === 'shop') {
            _statusText = intl.formatMessage({ id: 'shop.status.completed' })
            if (basket.shippingProvider === 'lalamove') {
              shouldShowResubmitBtn = false
            }
          } else {
            _statusText = intl.formatMessage({ id: 'takeaway.status.completed' })
          }
          break
        case 'delivered':
          _statusText = intl.formatMessage({ id: 'takeaway.status.delivered' })
          shouldShowResubmitBtn = true
          break
        default:
          _statusText = intl.formatMessage({ id: 'takeaway.status.pending' })
          takeawayOrderStatusTextStyle = cx(classes['takeaway-order-status-text'])
          shouldShowResubmitBtn = false
          break
      }

      if (this.state.basket.delivery) {
        const deliveryStatus = _.get(this.state.basket, 'deliveryStatus')
        if (['enroute', 'delivered'].includes(deliveryStatus)) {
          _statusText = intl.formatMessage({ id: `delivery.deliverystatus.${deliveryStatus}` })
          shouldShowResubmitBtn = false
          if (deliveryStatus === 'delivered') {
            shouldShowResubmitBtn = true
          }
        }
      }

      const renderResubmitButton = () => {
        const _reorderText = intl.formatMessage({ id: 'checkout.reorder' })
        return (
          <span className={takeawayOrderStatusStyle}>
            <span
              className={resumbitBtnStyle}
              onClick={this.handleBackToHome}
            >
              {_reorderText}
            </span>
          </span>
        )
      }

      return (
        <React.Fragment>
          <div className={takeawayStatusBodyStyle}>
            <div className={bgShapeCheckoutStyle} />
            <div className={takeawayOrderStatusContentStyle}>
              <span className={headerStyle}>
                <img className={cookingImageStyle} alt='' src={cookingImage} />
                <span className={takeawayOrderStatusTextStyle}>{_statusText}</span>
              </span>
              {
              // if this.state.basket.delivery === true , hide {resubmitBtn}
                this.state.basket.delivery !== true && shouldShowResubmitBtn && renderResubmitButton()
              }
            </div>
          </div>

          {
          // shouldShowResubmitBtn => show disabled "訂單完成後可重新下單" button
            (this.state.basket.delivery === true && shouldShowResubmitBtn) && (
              <div className={reorderLineStyle}>
                <div className={resubmitAfterOrderCompleteBtnStyle} onClick={this.handleBackToHome}>
                  {intl.formatMessage({ id: 'dialog.reorder' })}
                </div>
              </div>
            )
          }
          {
          // shouldShowResubmitBtn => show enabled "訂單完成後可重新下單" button
            (this.state.basket.delivery === true && !shouldShowResubmitBtn) && (
              <div className={reorderLineStyle}>
                <div className={resubmitAfterOrderCompleteBtnDisabledStyle}>
                  {intl.formatMessage({ id: 'takeaway.reorderAfterOrderComplete' })}
                </div>
              </div>
            )
          }
        </React.Fragment>
      )
    }

    if (this.state.basket.isStoreDelivery && this.isCampaignCCBMerchant) {
      return <Confirmation type='campaignCCB' />
    }
    return (
      <div className={containerStyle}>
        {renderRestaurantInfo()}
        {renderPickupCode()}
        {renderDeliveryAddress()}
        {renderDeliveryPickupAt()}
        {renderUserInfo()}
        {renderOrderStatus()}
      </div>
    )
  }
}

export default injectSheet(styles)(TakeawayWaitingSummaryComponent)



// WEBPACK FOOTER //
// ./src/components/TakeawayWaitingSummary.js